/* eslint-disable */
/**
 * CAT API client using native fetch() to avoid axios global interceptors.
 * Uses explicit base URL so nothing (env, interceptors, cache) can override it.
 */

import { env } from "../../../../../../config/EnvironmentConfig";
import { getCurrentCatConfig } from "./defaultConfigApi";

function getCatBaseUrl(): string {
  return env?.baseUrlCAT ?? env?.baseUrl ?? "";
}

export type CatFetchConfig = {
  baseURL: string;
  headers: Record<string, string>;
};

// Kept for backward compatibility — callers may still invoke setCatFetchConfig,
// but every request now reads headers fresh from localStorage via getCurrentCatConfig().
export function setCatFetchConfig(_config: CatFetchConfig): void {}

export function getCatFetchConfig(): CatFetchConfig {
  return getCurrentCatConfig();
}

/** GET request - returns { data } to match axios response shape */
export async function catFetchGet(path: string): Promise<{ data: any }> {
  const { baseURL, headers: freshHeaders } = getCurrentCatConfig();
  const base = baseURL || getCatBaseUrl();
  const url = path.startsWith("http") ? path : `${base.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      ...freshHeaders,
    },
  });
  if (!res.ok) {
    const err = new Error(res.statusText || `HTTP ${res.status}`);
    (err as any).response = { status: res.status, data: null };
    throw err;
  }
  const data = await res.json();
  return { data };
}

/** POST request - returns { data, status } to match axios response shape */
export async function catFetchPost(path: string, body: any): Promise<{ data: any; status: number }> {
  const { baseURL, headers: freshHeaders } = getCurrentCatConfig();
  const base = baseURL || getCatBaseUrl();
  const url = path.startsWith("http") ? path : `${base.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      ...freshHeaders,
    },
    body: JSON.stringify(body),
  });
  let data = null;
  const contentType = res.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") !== -1) {
    try {
      data = await res.json();
    } catch {
      // ignore
    }
  }
  if (!res.ok) {
    const err = new Error(res.statusText || `HTTP ${res.status}`);
    (err as any).response = { status: res.status, data };
    throw err;
  }
  return { data, status: res.status };
}
